import type { UpdateAccountLogoPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateAccountLogo(
  options?: UseMutationOptions<unknown, unknown, UpdateAccountLogoPayload>,
) {
  return useMutation({
    mutationFn: async ({ logo }) => {
      const api = getPrivateApi();

      return api.updateAccountLogo({ updateAccountLogoRequest: { logo } });
    },
    ...options,
  });
}
